import { Navigate } from "react-router-dom";
import { LOGIN } from "../../config/paths";
import { useAuthContext } from "../../context/authContext";

export default function PermissionRoute({
  permission,
  permissionsAny = [],
  children,
  fallback = "/PrivateMainPage/no-autorizado",
}) {
  const { isAuth, can, loading } = useAuthContext();

  if (loading) {
    return <div style={{textAlign:'center',marginTop:'40px'}}>Verificando sesión...</div>;
  }

  if (!isAuth) {
    return <Navigate to={LOGIN} replace />;
  }

  const hasSinglePermission = permission ? can(permission) : true;
  const hasAnyPermission = permissionsAny.length ? permissionsAny.some((candidate) => can(candidate)) : true;

  if (!hasSinglePermission || !hasAnyPermission) {
    return <Navigate to={fallback} replace />;
  }

  return children;
}
